interface TableHeaderProps {
  items: string[];
  px?: number;
}

export const TableHeader = ({ items, px = 2 }: TableHeaderProps) => {
  return (
    <thead className="bg-gray-100 uppercase text-xs border-b border-gray-300">
      <tr>
        {items.map((header, i) => {
          return (
            <th
              key={header}
              className={`px-${px} py-1 ${
                i !== 0 ? 'text-right' : 'text-left'
              }`}
            >
              {header}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
